{
  "el": {
    "constants": {
      "address": {
        "city": "Πόλη",
        "country": "Χώρα",
        "number": "Αριθμός",
        "street": "Οδός",
        "zip": "Τ.Κ."
      },
      "crud": {
        "created_at": "Δημιουργήθηκε στις",
        "deleted_at": "Διαγράφηκε στις",
        "updated_at": "Ενημερώθηκε στις"
      },
      "currencies": {
        "all": "Όλα τα νομίσματα",
        "popular": "Δημοφιλή"
      },
      "days": ["Κυ", "Δε", "Τρ", "Τε", "Πε", "Πα", "Σα"],
      "languages": {
        "de": "Γερμανικά",
        "el": "Ελληνικά",
        "en": "Αγγλικά",
        "es": "Ισπανικά",
        "fallback_info": "Φαίνεται πως αυτό δεν είναι διαθέσιμο στη γλώσσα σου. Χρησιμοποιούμε αντ' αυτού την υπάρχουσα μετάφραση στα {fallback_locale}.",
        "fr": "Γαλλικά",
        "it": "Ιταλικά",
        "nl": "Ολλανδικά",
        "pl": "Πολωνικά",
        "pt": "Πορτογαλικά"
      },
      "languages_short": {
        "de": "DE",
        "el": "EL",
        "en": "EN",
        "es": "ES",
        "fr": "FR",
        "it": "IT",
        "nl": "NL",
        "pl": "PL",
        "pt": "PT"
      },
      "measurements": {
        "imperial": "Αγγλοσαξονικό",
        "metric": "Μετρικό",
        "surface": {
          "imperial": "Sq. ft",
          "metric": "m²",
          "null": ""
        }
      },
      "months": [
        "ιανουάριος",
        "φεβρουάριος",
        "μάρτιος",
        "απρίλιος",
        "μάιος",
        "ιούνιος",
        "ιούλιος",
        "αύγουστος",
        "σεπτέμβριος",
        "οκτώβριος",
        "νοέμβριος",
        "δεκέμβριος"
      ],
      "profile_statuses": {
        "active": "Ενεργό",
        "added": "Δεν έχει προσκληθεί ακόμα",
        "blocked": "Απενεργοποιημένο",
        "discarded": "Διαγραμμένο",
        "invited": "Προσκεκλημένο",
        "invited_at": "Προσκεκλημένο"
      },
      "profile_statuses_descriptive": {
        "active": "Τελευταία φορά ενεργό στην πλατφόρμα: {session_ended_at}",
        "added": "Δεν έχει προσκληθεί ακόμα",
        "blocked": "Απενεργοποιημένο",
        "discarded": "Διαγραμμένο",
        "invited": "Προσκεκλημένο αλλά δεν έχει εγγραφεί ακόμα",
        "invited_at": "Προσκεκλημένο {invited_at}. Δεν έχει εγγραφεί ακόμα"
      },
      "profile_titles": {
        "dr": "Δρ",
        "mr": "Κύριος",
        "mrs": "Κυρία",
        "professor": "Καθηγητής",
        "sirmadam": "-"
      },
      "time_units": {
        "days": "Ημέρες",
        "months": "Μήνες",
        "weeks": "Εβδομάδες"
      },
      "time_units_count": {
        "days": "καμία ημέρα | ημέρα | ημέρες",
        "months": "κανένας μήνας | μήνας | μήνες",
        "weeks": "καμία εβδομάδα | εβδομάδα | εβδομάδες"
      },
      "timezone_regions": {
        "Africa": "Αφρική",
        "America": "Αμερική",
        "Asia": "Ασία",
        "Atlantic": "Ατλαντικός",
        "Australia": "Αυστραλία",
        "Europe": "Ευρώπη",
        "Pacific": "Ειρηνικός"
      },
      "timezones": {
        "Africa/Abidjan": "Αφρική/Αμπιτζάν",
        "Africa/Cairo": "Αφρική/Κάιρο",
        "Africa/Casablanca": "Αφρική/Καζαμπλάνκα",
        "Africa/Johannesburg": "Αφρική/Γιοχάνεσμπουργκ",
        "Africa/Lagos": "Αφρική/Λάγος",
        "Africa/Nairobi": "Αφρική/Ναϊρόμπι",
        "America/Anchorage": "Αμερική/Άνκορατζ",
        "America/Bogota": "Αμερική/Μπογκοτά",
        "America/Buenos_Aires": "Αμερική/Μπουένος Άιρες",
        "America/Chicago": "Αμερική/Σικάγο",
        "America/Denver": "Αμερική/Ντένβερ",
        "America/Halifax": "Αμερική/Χάλιφαξ",
        "America/Lima": "Αμερική/Λίμα",
        "America/Los_Angeles": "Αμερική/Λος Άντζελες",
        "America/Mexico_City": "Αμερική/Πόλη του Μεξικού",
        "America/New_York": "Αμερική/Νέα Υόρκη",
        "America/Phoenix": "Αμερική/Φοίνιξ",
        "America/Santiago": "Αμερική/Σαντιάγο",
        "America/Sao_Paulo": "Αμερική/Σάο Πάολο",
        "America/St_Johns": "Αμερική/Σεντ Τζονς",
        "America/Toronto": "Αμερική/Τορόντο",
        "America/Vancouver": "Αμερική/Βανκούβερ",
        "Asia/Bangkok": "Ασία/Μπανγκόκ",
        "Asia/Colombo": "Ασία/Κολόμπο",
        "Asia/Dhaka": "Ασία/Ντάκα",
        "Asia/Dubai": "Ασία/Ντουμπάι",
        "Asia/Ho_Chi_Minh": "Ασία/Χο Τσι Μιν",
        "Asia/Hong_Kong": "Ασία/Χονγκ Κονγκ",
        "Asia/Jakarta": "Ασία/Τζακάρτα",
        "Asia/Karachi": "Ασία/Καράτσι",
        "Asia/Kolkata": "Ασία/Καλκούτα",
        "Asia/Kuala_Lumpur": "Ασία/Κουάλα Λουμπούρ",
        "Asia/Makassar": "Ασία/Μακασάρ",
        "Asia/Manila": "Ασία/Μανίλα",
        "Asia/Riyadh": "Ασία/Ριάντ",
        "Asia/Seoul": "Ασία/Σεούλ",
        "Asia/Shanghai": "Ασία/Σανγκάη",
        "Asia/Singapore": "Ασία/Σιγκαπούρη",
        "Asia/Taipei": "Ασία/Ταϊπέι",
        "Asia/Tehran": "Ασία/Τεχεράνη",
        "Asia/Tokyo": "Ασία/Τόκιο",
        "Atlantic/Reykjavik": "Ατλαντικός/Ρέικιαβικ",
        "Australia/Adelaide": "Αυστραλία/Αδελαΐδα",
        "Australia/Brisbane": "Αυστραλία/Μπρίσμπεϊν",
        "Australia/Darwin": "Αυστραλία/Ντάργουιν",
        "Australia/Hobart": "Αυστραλία/Χόμπαρτ",
        "Australia/Melbourne": "Αυστραλία/Μελβούρνη",
        "Australia/Perth": "Αυστραλία/Περθ",
        "Australia/Sydney": "Αυστραλία/Σίδνεϊ",
        "Europe/Amsterdam": "Ευρώπη/Άμστερνταμ",
        "Europe/Athens": "Ευρώπη/Αθήνα",
        "Europe/Belgrade": "Ευρώπη/Βελιγράδι",
        "Europe/Berlin": "Ευρώπη/Βερολίνο",
        "Europe/Brussels": "Ευρώπη/Βρυξέλλες",
        "Europe/Bucharest": "Ευρώπη/Βουκουρέστι",
        "Europe/Budapest": "Ευρώπη/Βουδαπέστη",
        "Europe/Copenhagen": "Ευρώπη/Κοπεγχάγη",
        "Europe/Dublin": "Ευρώπη/Δουβλίνο",
        "Europe/Helsinki": "Ευρώπη/Ελσίνκι",
        "Europe/Istanbul": "Ευρώπη/Κωνσταντινούπολη",
        "Europe/Lisbon": "Ευρώπη/Λισαβόνα",
        "Europe/London": "Ευρώπη/Λονδίνο",
        "Europe/Madrid": "Ευρώπη/Μαδρίτη",
        "Europe/Moscow": "Ευρώπη/Μόσχα",
        "Europe/Oslo": "Ευρώπη/Όσλο",
        "Europe/Paris": "Ευρώπη/Παρίσι",
        "Europe/Prague": "Ευρώπη/Πράγα",
        "Europe/Rome": "Ευρώπη/Ρώμη",
        "Europe/Stockholm": "Ευρώπη/Στοκχόλμη",
        "Europe/Vienna": "Ευρώπη/Βιέννη",
        "Europe/Warsaw": "Ευρώπη/Βαρσοβία",
        "Europe/Zurich": "Ευρώπη/Ζυρίχη",
        "Pacific/Auckland": "Ειρηνικός/Όκλαντ",
        "Pacific/Fiji": "Ειρηνικός/Φίτζι",
        "Pacific/Honolulu": "Ειρηνικός/Χονολουλού"
      },
      "wind_orientations": {
        "east": "Ανατολή",
        "north": "Βορράς",
        "northeast": "Βορειοανατολικά",
        "northwest": "Βορειοδυτικά",
        "select": "Επιλογή προσανατολισμού",
        "south": "Νότος",
        "southeast": "Νοτιοανατολικά",
        "southwest": "Νοτιοδυτικά",
        "west": "Δύση"
      }
    }
  }
}
